module.exports = __webpack_public_path__ + "img/icon2.02df62a9.svg";